import React from 'react'

const DragIcon = props => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.33333 4.00004C6.06971 4.00004 6.66666 3.40308 6.66666 2.66671C6.66666 1.93033 6.06971 1.33337 5.33333 1.33337C4.59695 1.33337 4 1.93033 4 2.66671C4 3.40308 4.59695 4.00004 5.33333 4.00004Z'
      fill='#8F8F8F'
    />
    <path
      d='M5.33333 9.3333C6.06971 9.3333 6.66666 8.73634 6.66666 7.99996C6.66666 7.26358 6.06971 6.66663 5.33333 6.66663C4.59695 6.66663 4 7.26358 4 7.99996C4 8.73634 4.59695 9.3333 5.33333 9.3333Z'
      fill='#8F8F8F'
    />
    <path
      d='M5.33333 14.6667C6.06971 14.6667 6.66666 14.0697 6.66666 13.3333C6.66666 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z'
      fill='#8F8F8F'
    />
    <path
      d='M10.6673 4.00004C11.4037 4.00004 12.0006 3.40308 12.0006 2.66671C12.0006 1.93033 11.4037 1.33337 10.6673 1.33337C9.93094 1.33337 9.33398 1.93033 9.33398 2.66671C9.33398 3.40308 9.93094 4.00004 10.6673 4.00004Z'
      fill='#8F8F8F'
    />
    <path
      d='M10.6673 9.3333C11.4037 9.3333 12.0006 8.73634 12.0006 7.99996C12.0006 7.26358 11.4037 6.66663 10.6673 6.66663C9.93094 6.66663 9.33398 7.26358 9.33398 7.99996C9.33398 8.73634 9.93094 9.3333 10.6673 9.3333Z'
      fill='#8F8F8F'
    />
    <path
      d='M10.6673 14.6667C11.4037 14.6667 12.0006 14.0697 12.0006 13.3333C12.0006 12.597 11.4037 12 10.6673 12C9.93094 12 9.33398 12.597 9.33398 13.3333C9.33398 14.0697 9.93094 14.6667 10.6673 14.6667Z'
      fill='#8F8F8F'
    />
  </svg>
)

export default DragIcon
